
export default {
  selectEvtInfoList: { // 이벤트 과정목록 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/enrolment/getEvtInfo'
  },
  checkRrn: { // 실명인증(고용보험 환급과정)을 수행
    method: 'GET',
    url: 'mrm/v1/permit/nrw/enrolment/checkRrn'
  },
  getTerms: { // 약관정보를 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/enrolment/getTerms'
    // url: 'mrm/v1/student/enrolment/getAcceptTerms'
  },
  getCltpInfo: { // 회사정보 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/enrolment/getCltpInfo'
  },
  selectSemAttlRefnd: { // 고용보험환급입금계좌번호 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/enrolment/selectSemAttlRefnd'
  },
  selectCltcpCds: { // 회사 검색
    method: 'GET',
    url: 'mrm/v1/permit/student/cltcpCds'
  },
  selectCorsDgrPrdtMgr: { // 소속회사 담당자 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/enrolment/selectCorsDgrPrdtMgr'
  },
  saveApplInfo: { // 수강신청정보 저장
    method: 'POST',
    url: 'mrm/v1/permit/nrw/enrolment/saveApplInfo'
  },
  updateJjim: { // 관련과정 찜하기
    method: 'POST',
    // showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/student/enrolment/updateJjim'
  },
  selectEnrolment: { // 수강신청 - 조건 체크 api
    method: 'GET',
    url: 'mrm/v1/permit/nrw/student/enrolment/getEnrolment'
  },
  selectApplInfoConSafety: { // 건설안전 아카데미 신청정보  조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/enrolment/selectApplInfoConSafety'
  },
  saveApplInfoConSafety: { // 수강신청정보 저장(건설안전 아카데미)
    method: 'POST',
    url: 'mrm/v1/permit/nrw/enrolment/saveApplInfoConSafety'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/enrolmentApi.js